import Vue from 'vue'
const componentsContext = require.context('../components', true, /\.vue/)
componentsContext.keys().forEach(component => {
  const componentConfig = componentsContext(component)
  const componentDefault = componentConfig.default || componentConfig
  Vue.component(componentDefault.name, componentDefault)
})



// WEBPACK FOOTER //
// ./src/components/index.js